var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scatter-farmacias-container",staticStyle:{"position":"relative"},attrs:{"width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }